"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _async = _interopRequireDefault(require("react-select/async"));

var _propTypes = require("prop-types");

var _Error = _interopRequireDefault(require("./../Messages/Error"));

var _CheckBox_v = _interopRequireDefault(require("../v2/Checkboxes/CheckBox_v2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SearchSelectInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var async = _ref.async,
      className = _ref.className,
      onSelected = _ref.onSelected,
      dataTestId = _ref.dataTestId,
      loading = _ref.loading,
      loadOptions = _ref.loadOptions,
      options = _ref.options,
      name = _ref.name,
      value = _ref.value,
      disabled = _ref.disabled,
      children = _ref.children,
      initial = _ref.initial,
      noOptionMessage = _ref.noOptionMessage,
      loadingMessage = _ref.loadingMessage,
      placeholder = _ref.placeholder,
      isMulti = _ref.isMulti,
      error = _ref.error,
      withCheckmark = _ref.withCheckmark,
      otherProps = _objectWithoutProperties(_ref, ["async", "className", "onSelected", "dataTestId", "loading", "loadOptions", "options", "name", "value", "disabled", "children", "initial", "noOptionMessage", "loadingMessage", "placeholder", "isMulti", "error", "withCheckmark"]);

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      isSelected = _useState2[0],
      setSelected = _useState2[1];

  var handleChange = function handleChange(option) {
    setSelected(option || []);

    if (!option) {
      onSelected({
        name: name,
        value: undefined
      });
      return;
    }

    onSelected({
      name: name,
      value: Array.isArray(option) ? option : option.value
    });
  };

  (0, _react.useEffect)(function () {
    if (loading || !options.length || options === []) {
      setSelected('');
    }

    if (initial) {
      setSelected(initial);
    }

    if (value) setSelected(value);
  }, [value, options, initial, loading]);

  var Option = function Option(_ref2) {
    var isSelected = _ref2.isSelected,
        value = _ref2.value,
        rest = _objectWithoutProperties(_ref2, ["isSelected", "value"]);

    Option.propTypes = {
      isSelected: _propTypes.bool,
      value: _propTypes.any
    };
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, rest, /*#__PURE__*/_react.default.createElement(Flex, null, /*#__PURE__*/_react.default.createElement(Checkbox, {
      checked: isSelected,
      onChange: function onChange() {
        return null;
      }
    }), ' ', /*#__PURE__*/_react.default.createElement("label", null, value), ' ')), ' ');
  };

  return /*#__PURE__*/_react.default.createElement(Container, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(Label, _extends({
    disabled: disabled
  }, otherProps), children, !async ? /*#__PURE__*/_react.default.createElement(Input, _extends({
    ref: ref,
    dataTestId: dataTestId,
    isDisabled: disabled,
    onChange: handleChange,
    name: name,
    options: options,
    value: isSelected,
    noOptionsMessage: function noOptionsMessage() {
      return noOptionMessage;
    },
    placeholder: loading ? loadingMessage : placeholder,
    classNamePrefix: "Select",
    isMulti: isMulti,
    closeMenuOnSelect: !isMulti,
    error: error ? true : false
  }, withCheckmark && {
    components: {
      Option: Option
    }
  }, withCheckmark && {
    hideSelectedOptions: false
  }, otherProps)) : /*#__PURE__*/_react.default.createElement(AsyncInput, _extends({
    ref: ref,
    dataTestId: dataTestId,
    isDisabled: disabled,
    onChange: handleChange,
    placeholder: loading ? loadingMessage : placeholder,
    classNamePrefix: "Select",
    isMulti: isMulti,
    name: name,
    closeMenuOnSelect: !isMulti,
    error: error ? true : false,
    cacheOptions: true,
    value: isSelected,
    loadOptions: loadOptions,
    defaultOptions: true
  }, withCheckmark && {
    components: {
      Option: Option
    }
  }, withCheckmark && {
    hideSelectedOptions: false
  }, otherProps))), /*#__PURE__*/_react.default.createElement(_Error.default, {
    error: error
  }));
});
var styles = (0, _styledComponents.css)(["width:100%;margin-top:0.8rem;margin-bottom:", ";&:focus{outline:none;}& .Select{&__control{border-radius:0.3rem;border:0.1rem solid;border-color:", ";box-shadow:none;height:", ";&:hover{border-color:", ";}}&__control--menu-is-open{&:hover{border-color:", ";}.Select__dropdown-indicator{& svg{transform:rotate(180deg);transition:0.1s ease;}}}&__value-container{padding:0.5em;font-size:1.6rem;}&__single-value{color:black;overflow:visible;overflow:initial;}&__menu{font-size:1.8rem;z-index:999;}&__menu-list{max-height:13rem;padding:0;}&__menu-notice--no-options{text-align:left;font-size:1.2rem;}&__option{font-size:1.4rem;color:", ";padding:1rem;:hover{cursor:pointer;background-color:", ";color:", ";}&--is-focused{color:", ";background-color:", ";}&--is-selected{color:", ";background-color:white;}}&__multi-value{background:rgba(255,128,0,0.05);border:1px solid ", ";box-sizing:border-box;border-radius:3px;&__label{color:", ";line-height:1.6rem;padding:0.2rem 0.2rem 0.2rem 0.4rem;box-sizing:border-box;}&__remove{cursor:pointer;& svg{fill:", ";}&:hover{background-color:initial;}}}}"], function (_ref3) {
  var error = _ref3.error;
  return error ? 0 : '2rem';
}, function (_ref4) {
  var theme = _ref4.theme,
      error = _ref4.error,
      touched = _ref4.touched;
  return error ? theme.status.error : touched & !error ? theme.status.succes : '#e4e4e4';
}, function (_ref5) {
  var isMulti = _ref5.isMulti;
  return isMulti ? 'fit-content' : '4rem';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.ui.interactive;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.ui.interactive;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.ui.interactive;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.hover.secondary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.brand.secondary;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.brand.secondary;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.hover.secondary;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.brand.primary;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.brand.primary;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.brand.primary;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.brand.primary;
});

var Flex = _styledComponents.default.div.withConfig({
  displayName: "Flex"
})(["display:flex;align-items:center;font-size:1.5rem;"]);

var Checkbox = (0, _styledComponents.default)(_CheckBox_v.default).withConfig({
  displayName: "Checkbox"
})(["margin-right:1rem;"]);

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container"
})(["display:flex;flex-direction:column;width:100%;font-family:", ";min-height:9rem;"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.font;
});

var Label = _styledComponents.default.label.withConfig({
  displayName: "Label"
})(["display:flex;flex-direction:column;font-size:1.4rem;transition:0.2s;line-height:1rem;color:", ";"], function (_ref18) {
  var disabled = _ref18.disabled,
      theme = _ref18.theme;
  return disabled ? theme.ui.disabled : theme.labels.guaranteeText;
});

var Input = (0, _styledComponents.default)(_reactSelect.default).withConfig({
  displayName: "Input"
})(["", ";"], styles);
var AsyncInput = (0, _styledComponents.default)(_async.default).withConfig({
  displayName: "AsyncInput"
})(["", ";"], styles);
SearchSelectInput.displayName = 'SearchSelectInput';
SearchSelectInput.defaultProps = {
  async: false,
  disabled: false,
  loading: false,
  noOptionMessage: 'No options',
  options: [],
  loadingMessage: 'Loading...',
  placeholder: 'Choose your option',
  initial: null,
  isMulti: false,
  withCheckmark: false,
  otherProps: {},
  value: null
};
SearchSelectInput.propTypes = {
  dataTestId: _propTypes.string,
  async: _propTypes.bool,

  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Returns name and value of selected */
  onSelected: _propTypes.func,

  /** Sets name of inputfield */
  name: _propTypes.string,

  /** if true input is disabled */
  disabled: _propTypes.bool,

  /** string with errormessage */
  error: _propTypes.any,

  /** label above the input */
  children: _propTypes.node,

  /** array of objects {value: 'test', label: 'Test'} */
  options: _propTypes.any,

  /** set true if options are loading */
  loading: _propTypes.bool,

  /** name that sets selected on load */
  loadOptions: _propTypes.func,

  /** If a checkmark should be showed if it is selected */
  withCheckmark: _propTypes.bool,

  /** Initial */
  initial: _propTypes.any,

  /** Message to show when options are empty */
  noOptionMessage: _propTypes.string,

  /** Message to show when loading is true */
  loadingMessage: _propTypes.string,

  /** Message to show on load when no initial */
  placeholder: _propTypes.string,

  /** Defines if it can handle multiple tags */
  isMulti: _propTypes.bool,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,

  /** Triggers when input is cleared */
  value: _propTypes.any
};
var _default = SearchSelectInput;
exports.default = _default;